import React from 'react';
import _ from 'lodash';

import InputCurrencyField from './InputCurrencyField';
import InvoiceLineItemEntryTable from './InvoiceLineItemEntryTable';
import InvoiceLineItemTableRowStandardFields from './InvoiceLineItemTableRowStandardFields';
import InvoiceLineItemTableRowValidationFields from './InvoiceLineItemTableRowValidationFields';

import withInvoice from '../Common/WithInvoice';

import './InvoiceLineItemTableRow.scss';

class InvoiceLineItemTableRow extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      displayLineItemEntries: (props.newMode || props.adjustmentMode)
    };
  }

  _onLineItemEntryChange = (ident, value) => {
    const entries = _.cloneDeep(this.props.lineItem.fields.entries.value);

    if (ident === null) {
      entries.push(value);
    } else if (value === null) {
      entries.splice(ident, 1);
    } else {
      entries[ident] = value;
    }

    this._onChange('entries')(entries);
  }

  _onChange(inputId) {
    return value => {
      const { onChange } = this.props;

      const lineItem = _.cloneDeep(this.props.lineItem);
      lineItem.fields[inputId].value = value;

      onChange(lineItem);
    };
  }

  handleToggleLineItemEntriesClick = () => {
    this.setState({
      displayLineItemEntries: !this.state.displayLineItemEntries
    });
  }

  renderLineItemMetaFields() {
    const {
      lineItem,
      subscription,
      rates,
      inputId,
      newMode,
      adjustmentMode,
      fieldConfiguration,
      allowMetadataEditing,
      invoice,
      onChange,
      lineItemFeeTypes,
      id,
      fees,
      updateSelectedFees,
      selectedFees,
    } = this.props;

    if (invoice.isValidation) {
      return (
        <InvoiceLineItemTableRowValidationFields
          lineItem={lineItem}
          inputId={inputId}
          newMode={newMode}
          onChange={onChange}
          fieldConfiguration={fieldConfiguration}
        />
      );
    }

    return (
      <InvoiceLineItemTableRowStandardFields
        lineItem={lineItem}
        subscription={subscription}
        taxExempt={subscription?.fields.tax_exempt.value}
        rates={rates}
        fees={fees}
        selectedFees={selectedFees}
        inputId={inputId}
        newMode={newMode}
        adjustmentMode={adjustmentMode}
        fieldConfiguration={fieldConfiguration}
        allowMetadataEditing={allowMetadataEditing}
        onChange={onChange}
        isCarryover={invoice.isCarryover}
        _onLineItemEntryChange={this._onLineItemEntryChange}
        lineItemFeeTypes={lineItemFeeTypes}
        id={id}
        updateSelectedFees={updateSelectedFees}
      />
    );
  }

  render() {
    const {
      lineItem,
      inputId,
      newMode,
      adjustmentMode,
      fieldConfiguration,
      subscription,
    } = this.props;

    const {
      displayLineItemEntries
    } = this.state;

    const amountValue = lineItem.getAdjustedGrossAmount();
    const balanceValue = lineItem.getCurrentBalance();

    const lineItemEntryTableRows = lineItem.fields.entries.value.map(
      (entry, index) => ({ ident: index, data: entry })
    );

    return (
      <div className="parkchirp--invoice-line-item-table-row">
        {
          <div className="parkchirp--invoice-line-item-table-row--line-item-container">
            {this.renderLineItemMetaFields()}
            <div className="parkchirp--invoice-line-item-table--amount-column parkchirp--invoice-line-item-table--cell">
              <InputCurrencyField inputId={`${inputId}--amount`}
                key={`amount--${amountValue}`}
                value={amountValue}
                editMode={false}
              />
            </div>
            <div className="parkchirp--invoice-line-item-table--balance-column parkchirp--invoice-line-item-table--cell">
              <InputCurrencyField inputId={`${inputId}--balance`}
                key={`balance--${balanceValue}`}
                value={balanceValue}
                editMode={false}
              />
            </div>
            <div className="parkchirp--invoice-line-item-table--actions-column parkchirp--invoice-line-item-table--cell">
              {(!newMode && !adjustmentMode) &&
                <button type="button" onClick={this.handleToggleLineItemEntriesClick}>...</button>
              }
            </div>
          </div>
        }
        {((displayLineItemEntries || adjustmentMode)) &&
          <div className="parkchirp--invoice-line-item-table-row--line-item-entry-container">
            <InvoiceLineItemEntryTable inputId={`${inputId}--line-item-entries`}
              lineItemEntryRows={lineItemEntryTableRows}
              newMode={newMode}
              adjustmentMode={adjustmentMode}
              onLineItemEntryChange={this._onLineItemEntryChange}
              fieldConfiguration={fieldConfiguration}
              taxExempt={subscription?.fields.tax_exempt.value}
            />
          </div>
        }
      </div>
    );
  }
}

export default withInvoice(InvoiceLineItemTableRow);
